import { Pipe, PipeTransform } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { isObservable, of, from, Observable } from 'rxjs';

@Pipe({
  name: 'filterObservable'
})
export class FilterObservablePipe implements PipeTransform {
  element: any = null;
  months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre',
    'Octubre', 'Noviembre', 'Diciembre'];

  transform(valueSearch: any, data: any, args?: any): any {
    let info: any;
    let dataDoc: any;
    if (isObservable(data)) {
      return data.pipe(switchMap(
        res => {
          if (res) {
            if (args && args.length > 0) {
              info = res[valueSearch];
              const arrInfo = this.checkJoinArgs(info, res, args);
              if (arrInfo.length === 2) {
                return arrInfo[1];
              } else {
                return of(arrInfo[0]);
              }
            } else {
              info = res[valueSearch];
              // console.log(res[valueSearch]);
              return of(info);
            }
          }
          return of('');
        }
      )
      );
    } else if (data && data.id) {
      dataDoc = data.get().then(x => {
        if (x && x.data()) {
          info = x.data()[valueSearch];
          if (args && args.length > 0) {
            const arrInfo = this.checkJoinArgs(info, x.data(), args);
            if (arrInfo.length === 2) {
              return arrInfo[1];
            } else {
              return arrInfo[0];
            }
          } else {
            return info;
          }
        }
        return '';
      });

      return dataDoc;
    }
  }

  checkJoinArgs(info: any, res: any, args: any): any[] {
    let flag = false;
    let valRef = null;
    const arraPush = [];
    args.forEach(value => {
      if (typeof res[value.name] === 'string' && !value.calculate) {

        info += value.prevSeparator;
        info += value.itemSeparator + res[value.name];
        info += value.postSeparator;

      } else if (Array.isArray(res[value.name])) {

        const objectVal = res[value.name];
        info += value.prevSeparator;
        objectVal.forEach((x, index) => {
          if (index < objectVal.length - 1) {
            if (x && x.id) {
              valRef = x.get().then(dat => {
                const data = dat.data();
                info += value.prevSeparator;
                info += value.itemSeparator + data[value.nameRef];
                info += value.postSeparator;
                return info;
              });
              flag = true;
            } else {
              info += x + value.itemSeparator;
            }
          } else {
            if (x && x.id) {
              valRef = x.get().then(dat => {
                const data = dat.data();
                info += value.prevSeparator;
                info += value.itemSeparator + data[value.nameRef];
                info += value.postSeparator;
                return info;
              });
              flag = true;
            } else {
              info += x;
            }
          }
        });
        info += value.postSeparator;

      } else if (res[value.name] && res[value.name].id) {
        valRef = res[value.name].get().then(x => {
          const data = x.data();
          info += value.prevSeparator;
          info += value.itemSeparator + data[value.nameRef];
          info += value.postSeparator;
          return info;
        });

        flag = true;

      } else if (res[value.name] instanceof Object && !value.calculate) {

        const objectVal = res[value.name];
        info += value.prevSeparator;
        if (value.values && value.values.length > 0) {
          value.values.forEach((x, index) => {
            if (index < value.values.length - 1) {
              info += objectVal[x] + value.itemSeparator;
            } else {
              info += objectVal[x];
            }
          });
          info += value.postSeparator;
        } else if (value.typeObject === 'date') {
          info = this.objectToDate(res[value.name], info);
        }
      } else if (value && value.calculate) {
        const objectVal = res[value.name];
        info += value.prevSeparator;
        info += value.itemSeparator + value.calculate(objectVal);
        info += value.postSeparator;
      }
    });

    arraPush.push(info);
    if (flag) {
      arraPush.push(valRef);
    }

    return arraPush;
  }

  objectToDate(data: any, newData: any): any {
    if (data && data.seconds) {
      newData += this.dateConverter(data.seconds);
    } else {
      if (data && data.hour && (data.second || data.second === 0)) {
        newData += this.timeConverter(data);
      }
      if (data && data.year && data.month && data.day) {
        newData += data.day + ' ' + this.months[data.month] + ' ' + data.year;
      }
    }
    return newData;
  }

  dateConverter(timestamp): string {
    const a = new Date(timestamp * 1000);
    const year = a.getFullYear();
    const month = this.months[a.getMonth()];
    const date = a.getDate();
    const hour = a.getHours();
    const min = a.getMinutes();
    const sec = a.getSeconds();
    // const time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
    const time = date + ' ' + month + ' ' + year;
    return time;
  }
  timeConverter(time: any): string {
    const objKey = { 0: '00' };
    const minute = (objKey[time.minute]) ? objKey[time.minute] : time.minute;
    return time.hour + ':' + minute;
  }

}
